import { useAppSelector } from '@/hooks/useAppSelector';
import clsx from 'clsx';
import React, { FunctionComponent } from 'react';
import { useEmbedControl } from '@/contexts/EmbedControl';
import {
  hasItemsInCartSelector,
  totalNumberOfItemsInCartSelector,
  reservationEndTimeSelector,
} from '@/store/selectors/reservation';
import { Button } from '../Button';
import { Timer } from '../overrides/Header/Timer';

export const CartControl: FunctionComponent = () => {
  const control = useEmbedControl();

  const hasItems = useAppSelector(hasItemsInCartSelector);
  const itemsNumber = useAppSelector(totalNumberOfItemsInCartSelector);
  const reservationEndTime = useAppSelector(reservationEndTimeSelector);

  const canInteractWithCheckout = hasItems && control;

  const handleOpenCheckout = () => {
    if (!canInteractWithCheckout) return;
    control.openCheckout();
  };

  return (
    <div className="header__actions">
      {reservationEndTime > 0 && <Timer />}
      <Button
        variant={hasItems ? 'primary' : 'clear'}
        size="small"
        className={clsx('cart-button', {
          'cart-button--no-items': !hasItems,
        })}
        onClick={handleOpenCheckout}
      >
        {hasItems && <span className="cart__items-badge">{itemsNumber}</span>}
        <div className="cart-info">
          <i className="icon-shopping_cart" aria-hidden="true"></i>
        </div>
        <p>Cart</p>
      </Button>
    </div>
  );
};
